module.exports = __webpack_public_path__ + "img/klcx_09.750294c9.jpg";